import useLanguageStore from "@stores/languageStore";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

const SEOHead = ({
	titleKey,
	descriptionKey,
	title,
	description,
	canonical,
	ogImage,
	ogType = "website",
}) => {
	const { t } = useTranslation();
	const { language } = useLanguageStore();
	const baseUrl = typeof window !== "undefined" ? window.location.origin : "";
	const pathname = typeof window !== "undefined" ? window.location.pathname : "";
	const currentUrl = typeof window !== "undefined" ? window.location.href : "";

	const metaTitle = title || (titleKey ? t(titleKey) : t("common.appName"));
	const metaDescription =
		description || (descriptionKey ? t(descriptionKey) : "");
	const canonicalUrl = canonical || `${baseUrl}${pathname}`;
	const ogImageUrl = ogImage || `${baseUrl}/static/hero-tomb.png`;

	return (
		<Helmet>
			<title>{metaTitle}</title>
			{metaDescription && <meta name="description" content={metaDescription} />}
			<link rel="canonical" href={canonicalUrl} />
			<meta property="og:title" content={metaTitle} />
			{metaDescription && (
				<meta property="og:description" content={metaDescription} />
			)}
			<meta property="og:type" content={ogType} />
			<meta property="og:url" content={currentUrl} />
			<meta property="og:image" content={ogImageUrl} />
			<meta
				property="og:locale"
				content={language === "he" ? "he_IL" : "en_US"}
			/>
			<meta
				property="og:locale:alternate"
				content={language === "he" ? "en_US" : "he_IL"}
			/>
			<meta name="twitter:card" content="summary_large_image" />
			<meta name="twitter:title" content={metaTitle} />
			{metaDescription && (
				<meta name="twitter:description" content={metaDescription} />
			)}
			<meta name="twitter:image" content={ogImageUrl} />
			<html lang={language} />
		</Helmet>
	);
};

export default SEOHead;
